import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { updateFeeSchedule } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useUpdateFeeScheduleQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.UpdateFeeSchedule], updateFeeSchedule, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerDashboard])
        toast.success(AppNotification.UpdateFeeScheduleSuccess)
      } else {
        toast.error(`${AppNotification.UpdateFeeScheduleFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.UpdateFeeScheduleFailure)
    }
  })
}
